import { render, staticRenderFns } from "./GeneralSpreadSelectorV3.vue?vue&type=template&id=205445ac&scoped=true"
import script from "./GeneralSpreadSelectorV3.vue?vue&type=script&lang=js"
export * from "./GeneralSpreadSelectorV3.vue?vue&type=script&lang=js"
import style0 from "./GeneralSpreadSelectorV3.vue?vue&type=style&index=0&id=205445ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205445ac",
  null
  
)

export default component.exports